(function(){
  function init(root){
    var act=root.querySelector('[data-sc-act]'), stage=root.querySelector('[data-sc-stage]');
    var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce) act.setAttribute('data-sc-span','1');
    var els=[].slice.call(root.querySelectorAll('.fs-board [data-at]'));
    var steps=[].slice.call(root.querySelectorAll('.fs-step'));
    var bar=root.querySelector('.fs-bar i'), now=root.querySelector('.fs-now'), last=-1;
    function frame(){
      var p=reduce?1:(parseFloat(act.style.getPropertyValue('--sc-p'))||0);
      if(p!==last){
        last=p; var n=0;
        els.forEach(function(e){var on=p>=+e.getAttribute('data-at');e.classList.toggle('on',on);if(on)n++});
        var cur=-1; steps.forEach(function(s,i){var on=p>=+s.getAttribute('data-at');s.classList.toggle('on',on);if(on)cur=i});
        steps.forEach(function(s,i){s.classList.toggle('cur',i===cur)});
        if(bar) bar.style.transform='scaleY('+Math.max(0,Math.min(1,p/0.92)).toFixed(3)+')';
        if(now) now.textContent=cur>=0?steps[cur].querySelector('span').textContent:steps[0].querySelector('span').textContent;
        stage.setAttribute('data-sc-verify-state',cur+'|'+n);
        stage.setAttribute('data-sc-verify-hold',p>=+(steps[steps.length-1]||{getAttribute:function(){return 1}}).getAttribute('data-at')?'true':'false');
      }
      requestAnimationFrame(frame);
    }
    frame();
  }
  function go(){
    if(!window.ScrollCraft){setTimeout(go,50);return}
    [].forEach.call(document.querySelectorAll('[data-fs]'),function(r){if(r.__fs)return;r.__fs=1;ScrollCraft.mount(r);init(r)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
